import React from "react";
import { LogUploadSourceType } from "types/api/aiRiskMgmt";

import { LogFileUpload } from "../GenericIntegration";

export default function SentinelOneLogsFileUpload() {
  return (
    <LogFileUpload
      sourceType={LogUploadSourceType.SENTINELONE}
      label="SentinelOne"
    />
  );
}
